import { useEffect, useState } from "react";
import api from "@/lib/api";
import { mediaUrl } from "@/lib/media";
import { Waves, Loader2 } from "lucide-react";

export default function Team() {
  const [items, setItems] = useState(null);
  useEffect(() => { api.get("/content/team").then((r) => setItems(r.data)).catch(() => setItems([])); }, []);

  return (
    <div className="max-w-7xl mx-auto px-5 sm:px-8 py-24">
      <div className="max-w-2xl mb-16">
        <span className="text-xs uppercase tracking-[0.2em] text-muted-foreground">Our Team</span>
        <h1 className="font-serif text-4xl sm:text-5xl tracking-tight mt-3 mb-4">The people behind the frequencies.</h1>
        <p className="text-muted-foreground leading-relaxed">A team of practitioners, sound therapists and researchers devoted to responsible voice-frequency wellness.</p>
      </div>
      {items === null ? (
        <div className="py-20 grid place-items-center"><Loader2 className="animate-spin text-primary" strokeWidth={1.5} /></div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {items.map((m, i) => (
            <div key={m.id} className="rounded-2xl border border-border bg-card p-8 flex gap-5" data-testid={`team-member-${i}`}>
              {m.image_url ? (
                <img src={mediaUrl(m.image_url)} alt={m.name} className="h-16 w-16 rounded-full object-cover shrink-0" />
              ) : (
                <span className="grid place-items-center h-16 w-16 rounded-full bg-primary/15 text-primary shrink-0 font-serif text-2xl">{m.name.split(" ").map((n) => n[0]).slice(0, 2).join("")}</span>
              )}
              <div>
                <h3 className="font-serif text-xl">{m.name}</h3>
                <p className="text-primary text-sm mb-3">{m.role}</p>
                <p className="text-muted-foreground text-sm leading-relaxed">{m.bio}</p>
              </div>
            </div>
          ))}
        </div>
      )}
      <div className="mt-14 rounded-2xl border border-border bg-muted/40 grain p-8 flex items-center gap-4">
        <Waves className="text-primary shrink-0" strokeWidth={1.5} />
        <p className="text-sm text-muted-foreground">Every report our team produces is a wellness screening — a set of risk indicators to observe, not a medical diagnosis.</p>
      </div>
    </div>
  );
}
